"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridStyle = void 0;
/**
 * Grid Line Style
 */
class GridStyle {
    /**
     * Constructor
     *
     * @param color
     *            color
     * @param width
     *            width
     */
    constructor(color, width) {
        /**
         * Grid line color
         */
        this.color = undefined;
        /**
         * Grid line width
         */
        this.width = 0;
        this.color = color;
        this.width = width;
    }
    /**
     * Create a new style
     *
     * @param color
     *            color
     * @param width
     *            width
     * @return style
     */
    static style(color, width) {
        return new GridStyle(color, width);
    }
    /**
     * Get the grid line color
     *
     * @return grid line color
     */
    getColor() {
        return this.color;
    }
    /**
     * Set the grid line color
     *
     * @param color
     *            grid line color
     */
    setColor(color) {
        this.color = color;
    }
    /**
     * Get the grid line width
     *
     * @return grid line width
     */
    getWidth() {
        return this.width;
    }
    /**
     * Set the grid line width
     *
     * @param width
     *            grid line width
     */
    setWidth(width) {
        this.width = width;
    }
}
exports.GridStyle = GridStyle;
//# sourceMappingURL=GridStyle.js.map